<mat-radio-group
  class="common-radio-group"
  [value]="_value"
  [disabled]="data?.disabled"
  [class.row]="data?.direction === 'row'"
  [class.column]="data?.direction === 'column'"
  (change)="onSelectionChange($event.value)"
  (blur)="onTouched()"
>
  @for (option of data?.options; track option.value) {
    <mat-radio-button
      [value]="option.value"
      [disabled]="option.disabled"
      [class.red-border]="(ngControl?.invalid && ngControl?.touched && data?.required)"
    >
      <!-- Added by Amisha on 11-06-2026 to stop label clicks from selecting the option.
           Reason: only the radio circle should change the selection, not the surrounding text area. -->
      <div
        class="radio-label"
        (click)="$event.preventDefault(); $event.stopPropagation()"
      >
        <wm-common-text
          [data]="{ text: option.label }">
        </wm-common-text>
      </div>
    </mat-radio-button>
  }
</mat-radio-group>
<!-- Added on 17-04-2026 by amisha to render the required validation text directly
     from the common radio component when the Angular control is invalid. -->
<!-- <div *ngIf="hasValidationError" class="text-red">Required</div> -->
